import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from '@/App';
import '@/fa-icons';
import '@/styles.css';
import { WithThemeProvider } from '@/theme';
import { KindeProvider } from '@kinde-oss/kinde-auth-react';
import { ReactRouterNavigationProvider } from '@/hooks/useNavigationContext';
import { token } from './token';

const env = (import.meta as any).env as any;

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <BrowserRouter>
      <WithThemeProvider>
        <ReactRouterNavigationProvider>
          <KindeProvider
            clientId={env.VITE_REACT_APP_KINDE_TOKEN_CLIENT_ID || ''}
            domain={env.VITE_REACT_APP_KINDE_TOKEN_DOMAIN || ''}
            logoutUri={env.VITE_REACT_APP_APP_URL}
            redirectUri={env.VITE_REACT_APP_APP_URL}
            callbacks={{
              onSuccess: async (user: any, state: any, context: any) => {
                // Deep link carried through the OAuth flow as app_state. Hand it
                // to App (via sessionStorage) so it navigates back there once the
                // session is live. Robust to browser storage being cleared on the
                // redirect, since it round-tripped through Kinde, not the browser.
                if (state?.returnTo) {
                  sessionStorage.setItem('returnTo', state.returnTo);
                }
                token.setTokenGetter(async () => {
                  if (!context.getToken) return undefined;
                  return await context.getToken();
                });
              },
              onError: (error: any, state: any, context: any) => {
                console.error('Kinde onError callback', {
                  error,
                  state,
                  context,
                });
              },
            }}
            useInsecureForRefreshToken={process.env.NODE_ENV === 'development'}
          >
            <App />
          </KindeProvider>
        </ReactRouterNavigationProvider>
      </WithThemeProvider>
    </BrowserRouter>
  </React.StrictMode>,
);
